module.exports = __webpack_public_path__ + "static/media/kh.f53cd143.webp";